export default __webpack_public_path__ + "static/media/layout-grid-with-details-16.35d0ce29.svg";